import React, { useEffect, useState } from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import Select from '../../../../../../components/input/Select/Select';
import ImageSection from '../section/ImageSection';
import VideoSection from '../section/VideoSection';
import AnimationSection from '../section/AnimationSection';
import SwipeSection from '../section/SwipeSection';
import TextSection from '../section/TextSection';
import SelectProductListForm from '../../../components/SelectProductListForm';
import Switch from '../../../../../../components/input/Switch';
import CountOfTotal from '../../../../../../components/CountOfTotal';
import InputForm from '../../../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../../../lib/formRules';
import { SectionTab } from '../../../types';
import {
  EVENT_SECTION_TYPE_SELECT_LIST_V2,
  MAXIMUM_NUMBER_OF_EVENT_SECTION_MOVE_TAB_TEXT,
  NUMBER_OF_EVENT_SECTION_ITEM_COUNT,
} from '../../../../../../constants/service/app/eventConstants';
import { EventSectionItemStyle } from './style';
import { EventDetailSectionItem, SectionType } from '../../../../../../types/query/event/detail';
import { REQUIRED_MSG } from '../../../../../../constants/service/common/formRulesConstants';

interface SectionContentProps extends FormComponentProps, SectionTab {
  sectionItem?: EventDetailSectionItem;
}
const SectionContent = (props: SectionContentProps) => {
  const { form, id, type, name, isSectionMobility, sectionItem } = props;
  const [tabTitle, setTabTitle] = useState(sectionItem?.tabTitle);

  useEffect(() => {
    setTabTitle(sectionItem?.tabTitle);
  }, [sectionItem?.tabTitle]);

  const handleChangeSectionType = (name: string, type: SectionType) => {
    const newSectionTabList = form.getFieldValue('sectionTabList')?.map((item: SectionTab) => {
      if (item.name !== name) return item;

      return {
        ...item,
        type,
      };
    });

    form.setFieldsValue({
      sectionTabList: newSectionTabList,
      [`${name}-attachments`]: [],
    });
  };

  const handleChangeSwitch = (data: boolean) => {
    // switch 활성화 시 탭 타이틀 초기화
    if (data) {
      setTabTitle('');
    }

    const sectionTabList: SectionTab[] = form.getFieldValue('sectionTabList');
    form.setFieldsValue({
      sectionTabList: sectionTabList.map((item) => (item.id === id ? { ...item, isSectionMobility: data } : item)),
    });
  };

  return (
    <EventSectionItemStyle>
      <div className="select-section-type">
        <span className="label">기획전 섹션 타입 선택</span>
        <Select
          list={EVENT_SECTION_TYPE_SELECT_LIST_V2}
          onChange={(_type: SectionType) => {
            handleChangeSectionType(name, _type);
          }}
          disabled={!!sectionItem}
          value={type}
          size="large"
        />
        {sectionItem ? <div className="help-text">등록된 기획전 섹션 타입은 편집이 불가합니다.</div> : null}
      </div>
      <div className="section-navigation-tab">
        <div className="section-mobility-wrap">
          <div className="main-content">
            <div className="label">섹션 이동 여부</div>
            <div>
              <Switch checked={isSectionMobility} onChange={handleChangeSwitch} />
            </div>
          </div>
          <div className="sub-content">*섹션 이동 탭 사용 시, 기획전 별로 최소 2개의 섹션에 설정해야 합니다.</div>
        </div>
        {isSectionMobility ? (
          <InputForm
            name={`${name}-tabTitle`}
            form={form}
            label={
              <span>
                섹션 이동 탭 타이틀
                <CountOfTotal content={tabTitle} maxCnt={MAXIMUM_NUMBER_OF_EVENT_SECTION_MOVE_TAB_TEXT} />
              </span>
            }
            onChange={(data: string) => setTabTitle(data)}
            rules={[formRequiredRules(true, REQUIRED_MSG)]}
            initialValue={tabTitle}
            isTrim={false}
            maxLength={MAXIMUM_NUMBER_OF_EVENT_SECTION_MOVE_TAB_TEXT}
            subContent="*섹션 이동 탭 타이틀의 글자 수는 최대 15자 입니다. "
          />
        ) : null}
      </div>
      {type === 'image' && (
        <ImageSection
          form={form}
          name={name}
          sectionAttachmentList={sectionItem?.eventSectionAttachmentList}
          sectionClickLayerList={sectionItem?.eventSectionClickLayerList}
        />
      )}
      {type === 'video' && (
        <VideoSection form={form} name={name} sectionAttachmentList={sectionItem?.eventSectionAttachmentList} />
      )}
      {type === 'animation' && (
        <AnimationSection
          form={form}
          name={name}
          transitionDelay={sectionItem?.transitionDelay}
          sectionAttachmentList={sectionItem?.eventSectionAttachmentList}
        />
      )}
      {type === 'swipe' && (
        <SwipeSection
          form={form}
          name={name}
          isInfinity={sectionItem?.isInfinity}
          sectionAttachmentList={sectionItem?.eventSectionAttachmentList}
        />
      )}
      {type === 'text' && <TextSection name={name} form={form} title={sectionItem?.title} />}
      <hr />
      <div className="select-section-item-list">
        <span className="label">기획전 섹션 아이템으로 설정된 상품 리스트</span>
        <SelectProductListForm
          form={form}
          name={`${name}-product-items`}
          initialValue={sectionItem?.eventSectionProductList}
          max={NUMBER_OF_EVENT_SECTION_ITEM_COUNT}
        />
      </div>
    </EventSectionItemStyle>
  );
};

export default SectionContent;
